import {
  getOrderStatus,
  getProductStatus,
  getTransactionCounterStatus,
  getTransactionPersonalStatus,
  getTransactionStatus,
} from '../data/statuses';
import { Avatar, Box, Chip, Grid2 as Grid, Link, Typography } from '@mui/material';
import React from 'react';
import { getUserRole } from '../data/users';
import ViewSupplier from '../components/views/ViewSupplier';
import ViewCustomer from '../components/views/ViewCustomer';
import ViewUser from '../components/views/ViewUser';
import ViewOrder from '../components/views/ViewOrder';
import ViewOrderTransaction from '../components/views/ViewOrderTransaction';

export const kebabCase = (string) => {
  return string.replace(/([a-z])([A-Z])/g, '$1-$2').replace(/[\s_]+/g);
};

export const getNewDate = () => {
  // return new Date().setHours(0, 0, 0, 0);
  // return new Date().getTime();
  return new Date(new Date().setHours(0, 0, 0, 0)).getTime();
};

export const getNewDateTime = () => {
  // return new Date().setHours(0, 0, 0, 0);
  // return new Date().getTime();
  return new Date().getTime();
};

export const formatDate = (date) => {
  if (date === '') return '';
  return new Intl.DateTimeFormat('en-UK', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(date);
};

export const formatDateTime = (date) => {
  if (date === '') return '';
  return new Intl.DateTimeFormat('en-UK', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }).format(date);
};

export const parseDate = (date, type = 'start') => {
  if (!date) return '';

  const dateNow = new Date();
  const dateRegex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
  const match = date.match(dateRegex);
  // console.log('parseDate', match);
  if (!match) return '';

  let [, day, month, year] = match;
  day = parseInt(day, 10);
  month = parseInt(month, 10) - 1;
  year = parseInt(year, 10);
  let dateParsed = new Date(year, month, day);

  switch (type) {
    case 'start':
      // return new Date(dateParsed.setHours(0, 0, 0, 0)).getTime();
      return new Date(year, month, day, 0, 0, 0, 0).getTime();
    case 'end':
      // return new Date(dateParsed.setHours(23, 59, 59, 9999)).getTime();
      return new Date(year, month, day, 23, 59, 59, 999).getTime();
    case 'now':
    default:
      return new Date(
        dateParsed.setHours(dateNow.getHours(), dateNow.getMinutes(), dateNow.getSeconds(), dateNow.getMilliseconds()),
      ).getTime();
  }
};

export const parseDateTime = (date) => {
  if (!date) return '';

  const dateTimeRegex = /^(\d{2})\/(\d{2})\/(\d{4}), (\d{2}):(\d{2}):(\d{2})$/;
  const match = date.match(dateTimeRegex);

  if (!match) {
    // console.log('parseDateTime', '!match', match);
    return '';
  }

  let [, day, month, year, hour, minute, seconds] = match;
  day = parseInt(day, 10);
  month = parseInt(month, 10) - 1;
  year = parseInt(year, 10);
  hour = parseInt(hour, 10);
  minute = parseInt(minute, 10);
  seconds = parseInt(seconds, 10);

  // console.log('parseDateTime', 'new date', new Date(year, month, day, hour, minute, seconds));
  return new Date(year, month, day, hour, minute, seconds).getTime();
};

export const renderValueProductStatusChipList = (value) => {
  if (value === undefined || value.length === 0) return '-';
  return (
    <Grid
      container
      spacing={1}
      flexDirection={'column'}
    >
      {value.map((item, index) => {
        return (
          <Grid
            size={'auto'}
            key={item}
          >
            {renderValueProductStatusChip(item)}
          </Grid>
        );
      })}
    </Grid>
  );
};

export const renderValueProductStatusChip = (value) => {
  const status = getProductStatus(value);
  if (!status) return '-';
  return (
    <Chip
      // icon={status.icon}
      color={status.color}
      label={status.name}
      size={'small'}
    />
  );
};

export const renderValueOrderStatusChip = (value) => {
  const status = getOrderStatus(value);
  if (!status) return null;
  return (
    <Chip
      // icon={status.icon}
      color={status.color}
      label={status.name}
      size={'small'}
    />
  );
};

export const renderValueTransactionStatusChip = (value) => {
  const status = getTransactionStatus(value);
  if (!status) return null;
  return (
    <Chip
      // icon={status.icon}
      color={status.color}
      label={status.name}
      size={'small'}
    />
  );
};

export const renderValueTransactionPersonalStatusChip = (value) => {
  const status = getTransactionPersonalStatus(value);
  if (!status) return null;
  return (
    <Chip
      // icon={status.icon}
      color={status.color}
      label={status.name}
      size={'small'}
    />
  );
};

export const renderValueTransactionCounterStatusChip = (value) => {
  const status = getTransactionCounterStatus(value);
  if (!status) return null;
  return (
    <Chip
      // icon={status.icon}
      color={status.color}
      label={status.name}
      size={'small'}
    />
  );
};

export const renderValueRoleChip = (value) => {
  const role = getUserRole(value);
  if (!role) return null;
  return (
    <Chip
      // icon={status.icon}
      color={role.color}
      label={role.name}
    />
  );
};

export const renderValuePhotoURL = (value) => {
  return (
    <Box m={-1}>
      <Avatar
        alt="Image"
        src={value}
        variant={'rounded'}
        sx={{ width: 56, height: 56 }}
      />
    </Box>
  );
};

export const renderValueDate = (value) => {
  if (value) {
    return formatDate(value);
  } else {
    return '-';
  }
};

export const renderValueDateTime = (value) => {
  if (value) {
    return formatDateTime(value);
  } else {
    return '-';
  }
};

export const renderValueCurrency = (value) => {
  return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(value ?? 0);
};

export const startOfMonth = (year, month) => {
  // console.log('startOfMonth', year, month);
  return new Date(year, parseInt(month), 1, 0, 0, 0, 0);
};

export const endOfMonth = (year, month) => {
  // console.log('endOfMonth', year, month + 1);
  return new Date(year, parseInt(month) + 1, 0, 23, 59, 59, 999);
};

export const renderValueCustomerId = (value) => {
  return (
    <>
      <Typography component={'div'}>
        {value.surname} {value.name}
      </Typography>
      <Typography
        color={'textSecondary'}
        variant={'body2'}
        component={'div'}
      >
        {value.phone}
      </Typography>
    </>
  );
};

export const renderValueUserId = (value) => {
  return <Typography component={'div'}>{value.displayName}</Typography>;
};

export const renderValueSupplierId = (value) => {
  return (
    <>
      <Typography variant={'inherit'}>{value.name}</Typography>
      {/*<Typography*/}
      {/*  color={'textSecondary'}*/}
      {/*  variant={'body2'}*/}
      {/*>*/}
      {/*  {value.phone}*/}
      {/*</Typography>*/}
    </>
  );
};

export const renderValueSupplierRef = (value) => {
  // console.log(value);
  return value.name;
};

// export const renderValueSupplierId = (value) => {
//   // return value;
// };

export const renderFieldValue = (id, value, align) => {
  switch (id) {
    case 'customerId':
    case 'customerRef':
      // return renderValueCustomerId(value);
      return value && <ViewCustomer customerRef={value} />;
    case 'supplierId':
    case 'supplierRef':
      // return (
      //   <Typography
      //     align={align}
      //     variant={'body1'}
      //   >
      //     {renderValueSupplierRef(value)}
      //   </Typography>
      // );
      return value && <ViewSupplier supplierRef={value} />;
    case 'userRef':
      return value && <ViewUser userRef={value} />;
    case 'orderRef':
      return value && <ViewOrder orderRef={value} />;
    case 'orderTransaction':
      return value && <ViewOrderTransaction orderRef={value} />;
    // case 'supplierId':
    //   return renderValueSupplierId(value);
    case 'productStatus':
      return renderValueProductStatusChip(value);
    case 'productStatusList':
      return renderValueProductStatusChipList(value);
    case 'orderStatus':
      return renderValueOrderStatusChip(value);
    case 'transactionStatus':
      return renderValueTransactionStatusChip(value);
    case 'counterStatus':
      return renderValueTransactionCounterStatusChip(value);
    case 'personalStatus':
      return renderValueTransactionPersonalStatusChip(value);
    case 'role':
      return renderValueRoleChip(value);
    case 'photoURL':
      return renderValuePhotoURL(value);
    case 'date':
    case 'dateBackorder':
    case 'datePayment':
      return (
        <Typography
          align={align}
          variant={'body1'}
        >
          {renderValueDate(value)}
        </Typography>
      );
    case 'dateCreated':
    case 'dateOrdered':
    case 'dateReceived':
    case 'dateCompleted':
    case 'dateUpdated':
    case 'dateSignIn':
      return (
        <Typography
          align={align}
          variant={'body1'}
        >
          {renderValueDateTime(value)}
        </Typography>
      );
    case 'phone':
      return (
        <Link
          onClick={(e) => {
            e.stopPropagation();
            // e.preventDefault();
          }}
          variant={'body1'}
          href={`tel:${value}`}
        >
          {value}
        </Link>
      );
    case 'price':
    case 'total':
    case 'error':
    case 'downPayment':
    case 'taxesPayment':
    case 'blackPayment':
    case 'invoicePayment':
    case 'sequenceTotal':
      return (
        <Typography
          align={align}
          variant={'body1'}
        >
          {renderValueCurrency(value)}
        </Typography>
      );
    default:
      return (
        <Typography
          align={align}
          variant={'body1'}
          sx={{ wordBreak: 'break-word' }}
        >
          {value === '' ? '-' : value}
        </Typography>
      );
  }
};

export const getNestedObject = (obj, key) => {
  return key.split('.').reduce(function (o, x) {
    return typeof o == 'undefined' || o === null ? o : o[x];
  }, obj);
};
